// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgOCA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNC4yNjIwMSAzLjk5NDc3QzQuMTIxODUgNC4xMjczMSAzLjkzMTA2IDQuMjAxODYgMy43MzIwNCA0LjIwMTg2QzMuNTMzMDEgNC4yMDE4NiAzLjM0MjIyIDQuMTI3MzEgMy4yMDIwNyAzLjk5NDc3TDAuMjE2MzI1IDEuMTk0MjdDMC4wNzg0MjU0IDEuMDYzODYgMC4wMDA2ODMyNjYgMC44ODc4NTMgLTAuMDAwMTQxMTc3IDAuNzA0MTgzQy0wLjAwMTI4Nzk2IDAuNTE4MDg4IDAuMDc2NjAyNCAwLjMzOTIyMiAwLjIxNjMyNSAwLjIwNzA5NUMwLjM1NjQ4MSAwLjA3NDU1MjkgMC41NDcyNjcgLTIuODM3MTZlLTA3IDAuNzQ2Mjk0IC0yLjc1NTU2ZS0wN0MwLjk0NTMyMiAtMi42NzM5NmUtMDcgMS4xMzYxMSAwLjA3NDU1MjkgMS4yNzYyNiAwLjIwNzA5NUwzLjczMjA0IDIuNTEwNUw2LjE4NzgxIDAuMjIxMDk4QzYuMzc3MTUgMC4wNDM1MDU1IDYuNjUzMTIgLTAuMDI1ODUyMiA2LjkxMTc2IDAuMDM5MTUxMUM3LjE3MDQgMC4xMDQxNTQgNy4zNzI0MyAwLjI5MzY0MyA3LjQ0MTczIDAuNTM2MjM5QzcuNTExMDMgMC43Nzg4MzUgNy40MzcwOSAxLjAzNzY4IDcuMjQ3NzUgMS4yMTUyN0w0LjI2MjAxIDMuOTk0NzdaIiBmaWxsPSIjNkE4OTkxIi8+Cjwvc3ZnPgo=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  border-collapse: collapse;
  border: 1px solid #DBE7F1;
}

tr {
  border-top: 1px solid #DBE7F1;
}

th {
  padding: 10px 20px 10px 10px;
  color: #6A8991;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
}

td {
  background-color: white;
  font-size: 14px;
  padding: 10px 20px 10px 10px;
  font-weight: 500;
}

.link18 {
  color: blue;
  text-decoration: underline;
  font-size: 14px;
}

.font2, .ReactTags__tagInput input.ReactTags__tagInputField,
.ReactTags__tagInput input.ReactTags__tagInputField:focus, .ReactTags__tag, option {
  font-family: "Inter";
}

.fontSize10 {
  font-size: 10px;
}

.fontSize11 {
  font-size: 11px;
}

.fontSize12 {
  font-size: 12px;
}

.fontSize13 {
  font-size: 13px;
}

.fontSize14, .ReactTags__selected span.ReactTags__tag, .ReactTags__tagInput input.ReactTags__tagInputField,
.ReactTags__tagInput input.ReactTags__tagInputField:focus, .ReactTags__tag {
  font-size: 14px;
}

.fontSize15 {
  font-size: 15px;
}

#outer-container {
  background-color: #F7FAFC;
}

.errorText {
  padding: 5px;
  font-size: 14px;
  color: red;
}

input[type=radio] {
  margin-top: -1px;
}

body {
  font-family: "Inter";
  background-color: #F5F9FF;
  margin: 0;
  padding: 0;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

a, a:visited {
  color: #30A9B8;
  text-decoration: none;
}

.extended-table-row-container {
  display: flex;
  background: #113045;
  padding: 20px;
  border: 1px solid #0c424b;
  border-left-width: 0;
  border-right-width: 0;
  min-height: 150px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #d0dbe4;
  scrollbar-width: thin;
  scrollbar-gutter: stable;
}

::-webkit-scrollbar-thumb {
  background-color: #c0cedc;
  border-radius: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f6f2f2;
}

.container {
  margin: auto;
  width: 50%;
}

.ReactTags__tags {
  position: relative;
  display: flex;
  align-items: flex-start;
}

.timepicker, .timePicker {
  width: 60px !important;
  text-align: center;
}

select, video {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.flexRow {
  display: flex;
  align-items: center;
}

/* Styles for the input */
.ReactTags__tagInput {
  width: 270px;
  border-radius: 2px;
  display: inline-block;
}

.react-tags-wrapper {
  width: 90%;
  box-sizing: border-box;
  border: 1px solid #c3c8ca;
  outline: none;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.popup-footer {
  height: 50px;
  background-color: #eee;
  border-top: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
}

.ReactTags__tagInput input.ReactTags__tagInputField,
.ReactTags__tagInput input.ReactTags__tagInputField:focus {
  height: 31px;
  margin: 0;
  width: 100%;
  border: 0;
  padding-bottom: 2px;
  padding-left: 10px;
  outline: none;
}

/* Styles for selected tags */
.ReactTags__selected {
  outline: none;
  max-width: 500px;
}

.ReactTags__selected span.ReactTags__tag {
  border: 1px solid #ddd;
  background: #eee;
  display: inline-block;
  padding: 5px;
  margin: 3px 5px;
  border-radius: 2px;
}

.ReactTags__selected a.ReactTags__remove {
  color: #aaa;
  margin-left: 5px;
  cursor: pointer;
}

/* Styles for suggestions */
.ReactTags__suggestions {
  position: absolute;
}

.ReactTags__suggestions ul {
  list-style-type: none;
  box-shadow: 0.05em 0.01em 0.5em rgba(0, 0, 0, 0.2);
  background: white;
  width: 200px;
}

.ReactTags__suggestions li {
  border-bottom: 1px solid #ddd;
  padding: 5px 10px;
  margin: 0;
}

.ReactTags__suggestions li mark {
  text-decoration: underline;
  background: none;
  font-weight: 600;
}

.ReactTags__suggestions ul li.ReactTags__activeSuggestion {
  background: #b7cfe0;
  cursor: pointer;
}

.ReactTags__remove {
  border: none;
  cursor: pointer;
  background: none;
}

.tag {
  background-color: #EFF6F8;
  border: 1px solid #B9BEC0;
  border-radius: 4px;
  height: 30px;
  display: flex;
  align-items: center;
  padding: 0 5px;
  margin-right: 10px;
}

.tag:hover {
  color: white !important;
  background-color: black !important;
}

.react-confirm-alert-overlay {
  z-index: 9999;
}

.checkbox-primary {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid #40A0C1;
  background-color: #FFFFFF;
  position: relative;
  cursor: pointer;
}

.checkbox-primary:checked {
  background-color: #40A0C1;
}

.checkbox-primary:checked::before {
  content: "";
  position: absolute;
  display: block;
  left: 4.5px;
  top: 0.5px;
  width: 3px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.select-primary {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid #D3E1ED;
  border-radius: 5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 10px;
}

.radio-primary {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  appearance: none;
  -webkit-appearance: none;
  background-color: #D3E1ED;
  position: relative;
  cursor: pointer;
}

.radio-primary:checked {
  background-color: #40A0C1;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAkCA;EACC,yBAAA;EACA,yBAAA;AAjCD;;AAoCA;EACC,6BAAA;AAjCD;;AAoCA;EACC,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAjCD;;AAoCA;EACC,uBAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;AAjCD;;AAoCA;EACC,WAAA;EACA,0BAAA;EACA,eAAA;AAjCD;;AAoCA;;EACC,oBAAA;AAhCD;;AAmCA;EACC,eAAA;AAhCD;;AAmCA;EACC,eAAA;AAhCD;;AAmCA;EACC,eAAA;AAhCD;;AAmCA;EACC,eAAA;AAhCD;;AAmCA;;EACC,eAAA;AA/BD;;AAkCA;EACC,eAAA;AA/BD;;AAkCA;EACC,yBAnFO;AAoDR;;AAkCA;EACC,YAAA;EACA,eAAA;EACA,UAAA;AA/BD;;AAkCA;EACC,gBAAA;AA/BD;;AAkCA;EACC,oBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;AA/BD;;AAkCA;EACC,+EAAA;AA/BD;;AAmCA;EACC,cAAA;EACA,qBAAA;AAhCD;;AAuCA;EACC,aAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;AApCD;;AAoDA;EACC,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,wBAAA;AAjDD;;AAoDA;EACC,yBAAA;EACA,kBAAA;AAjDD;;AAoDA;EACC,yBAAA;AAjDD;;AAqDA;EACC,YAAA;EACA,UAAA;AAlDD;;AAyDA;EACC,kBAAA;EACA,aAAA;EACA,uBAAA;AAtDD;;AAyDA;EACC,sBAAA;EACA,kBAAA;AAtDD;;AAyDA;EACC,oCAAA;UAAA,4BAAA;AAtDD;;AAyDA;EACC,aAAA;EACA,mBAAA;AAtDD;;AAyDA,yBAAA;AACA;EACC,YAAA;EACA,kBAAA;EACA,qBAAA;AAtDD;;AAyDA;EACC,UAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAtDD;;AAyDA;EACC,YAAA;EACA,sBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAtDD;;AAyDA;;EAIC,YAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAxDD;;AA2DA,6BAAA;AACA;EACC,aAAA;EACA,gBAAA;AAxDD;;AA2DA;EAEC,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAzDD;;AA2DA;EACC,WAAA;EACA,gBAAA;EACA,eAAA;AAxDD;;AA2DA,2BAAA;AACA;EACC,kBAAA;AAxDD;;AA0DA;EACC,qBAAA;EACA,kDAAA;EACA,iBAAA;EACA,YAAA;AAvDD;;AAyDA;EACC,6BAAA;EACA,iBAAA;EACA,SAAA;AAtDD;;AAwDA;EACC,0BAAA;EACA,gBAAA;EACA,gBAAA;AArDD;;AAuDA;EACC,mBAAA;EACA,eAAA;AApDD;;AAuDA;EACC,YAAA;EACA,eAAA;EACA,gBAAA;AApDD;;AAuDA;EACC,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AApDD;;AAuDA;EACC,uBAAA;EACA,kCAAA;AApDD;;AAuDA;EACC,aAAA;AApDD;;AAuDA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AApDD;;AAuDA;EACE,yBAAA;AApDF;;AAwDA;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;AArDD;;AAwDA;EACC,gBAAA;EACC,wBAAA;EACA,qBAAA;EAED,yBAAA;EACA,kBAAA;EACC,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;AAtDF;;AAyDA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAtDD;;AAyDA;EACE,yBAAA;AAtDF","sourcesContent":["// Import the new popup design system\n@import './styles/popup-design-system.scss';\n\n$mobile:  \"(max-width: 765px)\";\n$tablet:  \"(min-width: 766px) and (max-width: 1023px)\";\n$desktop: \"(min-width: 1024px)\";\n\n\n$link: #465bab;\n$menuBg: #071623;\n$appBg: #F7FAFC;\n$mainBg: #F8FAFC;\n$mainTitle: #000000;\n$appBlue: #4070AE;\n$appGreen: #8AC93D;\n$appYellow: #feee96;\n$lightGreen: #AAFFAA;\n$lightBlue: #a5f2ff;\n$glowingBlue: #15d5f7;\n$glowingGreen: #00ffc7;\n$headerIcons: #ffffff;\n$buttonGreen: #8AC93D;\n$appDisabled: #dddddd;\n$lightText: #ddf3f6;\n$disabledText: #455465;\n$webPageBg: #1a4d73d1;\n$transparent: transparent;\n\n$headerHeight: 80px;\n$pageTitleHeight: 80px;\n\n* {\n}\n\ntable {\n\tborder-collapse:collapse;\n\tborder: 1px solid #DBE7F1;\n}\n\ntr {\n\tborder-top: 1px solid #DBE7F1;\n}\n\nth {\n\tpadding: 10px 20px 10px 10px;\n\tcolor: #6A8991;\n\tfont-weight: 500;\n\tfont-size: 14px;\n\ttext-align: left;\n}\n\ntd {\n\tbackground-color: white;\n\tfont-size: 14px;\n\tpadding: 10px 20px 10px 10px;\n\tfont-weight: 500;\n}\n\n.link18 {\n\tcolor: blue;\n\ttext-decoration: underline;\n\tfont-size: 14px;\n}\n\n.font2 {\n\tfont-family: 'Inter';\n}\n\n.fontSize10 {\n\tfont-size: 10px;\n}\n\n.fontSize11 {\n\tfont-size: 11px;\n}\n\n.fontSize12 {\n\tfont-size: 12px;\n}\n\n.fontSize13 {\n\tfont-size: 13px;\n}\n\n.fontSize14 {\n\tfont-size: 14px;\n}\n\n.fontSize15 {\n\tfont-size: 15px;\n}\n\n#outer-container {\n\tbackground-color: $appBg;\n}\n\n.errorText {\n\tpadding: 5px;\n\tfont-size: 14px;\n\tcolor: red;\n}\n\ninput[type=\"radio\"] {\n\tmargin-top: -1px;\n}\n\nbody {\n\tfont-family: 'Inter';\n\tbackground-color: #F5F9FF;\n\tmargin: 0;\n\tpadding: 0;\n}\n\ncode {\n\tfont-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n\tmonospace;\n}\n\na, a:visited {\n\tcolor: #30A9B8;\n\ttext-decoration: none;\n}\n\noption {\n\t@extend .font2;\n}\n\n.extended-table-row-container {\n\tdisplay: flex;\n\tbackground: #113045;\n\tpadding: 20px;\n\tborder: 1px solid #0c424b;\n\tborder-left-width: 0;\n\tborder-right-width: 0;\n\tmin-height: 150px;\n}\n\n// body::-webkit-scrollbar {\n// \twidth: 10px;\n// }\n\n// body::-webkit-scrollbar-track {\n// \tbox-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n// }\n\n// body::-webkit-scrollbar-thumb {\n// \tbackground-color: $glowingGreen;\n// \toutline: 1px solid slategrey;\n// }\n\n::-webkit-scrollbar {\n\twidth: 8px;\n\theight: 8px;\n\tbackground-color: #d0dbe4;\n\tscrollbar-width: thin;\n\tscrollbar-gutter: stable;\n}\n\n::-webkit-scrollbar-thumb {\n\tbackground-color: #c0cedc;\n\tborder-radius: 6px;\n}\n\n::-webkit-scrollbar-track {\n\tbackground-color: #f6f2f2;\n}\n\n\n.container {\n\tmargin: auto;\n\twidth: 50%;\n}\n.ReactTags__tag {\n\t@extend .font2;\n\t@extend .fontSize14;\n}\n\n.ReactTags__tags {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: flex-start;\n}\n\n.timepicker, .timePicker {\n\twidth: 60px !important;\n\ttext-align: center;\n}\n\nselect, video {\n\tuser-select: none !important;\n}\n\n.flexRow {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n/* Styles for the input */\n.ReactTags__tagInput {\n\twidth: 270px;\n\tborder-radius: 2px;\n\tdisplay: inline-block;\n}\n\n.react-tags-wrapper {\n\twidth: 90%;\n\tbox-sizing: border-box;\n\tborder: 1px solid #c3c8ca;\n\toutline: none;\n\tborder-radius: 5px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.popup-footer {\n\theight: 50px;\n\tbackground-color: #eee;\n\tborder-top: 1px solid #ddd;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tpadding: 0 20px;\n}\n\n.ReactTags__tagInput input.ReactTags__tagInputField,\n.ReactTags__tagInput input.ReactTags__tagInputField:focus {\n\t@extend .font2;\n\t@extend .fontSize14;\n\theight: 31px;\n\tmargin: 0;\n\twidth: 100%;\n\tborder: 0;\n\tpadding-bottom: 2px;\n\tpadding-left: 10px;\n\toutline: none;\n}\n\n/* Styles for selected tags */\n.ReactTags__selected {\n\toutline: none;\n\tmax-width: 500px;\n}\n\n.ReactTags__selected span.ReactTags__tag {\n\t@extend .fontSize14;\n\tborder: 1px solid #ddd;\n\tbackground: #eee;\n\tdisplay: inline-block;\n\tpadding: 5px;\n\tmargin: 3px 5px;\n\tborder-radius: 2px;\n}\n.ReactTags__selected a.ReactTags__remove {\n\tcolor: #aaa;\n\tmargin-left: 5px;\n\tcursor: pointer;\n}\n\n/* Styles for suggestions */\n.ReactTags__suggestions {\n\tposition: absolute;\n}\n.ReactTags__suggestions ul {\n\tlist-style-type: none;\n\tbox-shadow: .05em .01em .5em rgba(0,0,0,.2);\n\tbackground: white;\n\twidth: 200px;\n}\n.ReactTags__suggestions li {\n\tborder-bottom: 1px solid #ddd;\n\tpadding: 5px 10px;\n\tmargin: 0;\n}\n.ReactTags__suggestions li mark {\n\ttext-decoration: underline;\n\tbackground: none;\n\tfont-weight: 600;\n}\n.ReactTags__suggestions ul li.ReactTags__activeSuggestion {\n\tbackground: #b7cfe0;\n\tcursor: pointer;\n}\n\n.ReactTags__remove {\n\tborder: none;\n\tcursor: pointer;\n\tbackground: none;\n}\n\n.tag {\n\tbackground-color: #EFF6F8;\n\tborder: 1px solid #B9BEC0;\n\tborder-radius: 4px;\n\theight: 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0 5px;\n\tmargin-right: 10px;\n}\n\n.tag:hover {\n\tcolor: white !important;\n\tbackground-color: black !important;\n}\n\n.react-confirm-alert-overlay {\n\tz-index: 9999;\n}\n\n.checkbox-primary {\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 2px;\n\tappearance: none;\n\t-webkit-appearance: none;\n\tborder: 1px solid #40A0C1;\n\tbackground-color: #FFFFFF;\n\tposition: relative;\n\tcursor: pointer;\n}\n\n.checkbox-primary:checked {\n  background-color: #40A0C1;\n}\n\n\n.checkbox-primary:checked::before {\n\tcontent: \"\";\n\tposition: absolute;\n\tdisplay: block;\n\tleft: 4.5px;\n\ttop: 0.5px;\n\twidth: 3px;\n\theight: 8px;\n\tborder: solid white;\n\tborder-width: 0 2px 2px 0;\n\ttransform: rotate(45deg);\n}\n\n.select-primary {\n\tappearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n\tborder: 1px solid #D3E1ED;\n\tborder-radius: 5px;\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgOCA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNC4yNjIwMSAzLjk5NDc3QzQuMTIxODUgNC4xMjczMSAzLjkzMTA2IDQuMjAxODYgMy43MzIwNCA0LjIwMTg2QzMuNTMzMDEgNC4yMDE4NiAzLjM0MjIyIDQuMTI3MzEgMy4yMDIwNyAzLjk5NDc3TDAuMjE2MzI1IDEuMTk0MjdDMC4wNzg0MjU0IDEuMDYzODYgMC4wMDA2ODMyNjYgMC44ODc4NTMgLTAuMDAwMTQxMTc3IDAuNzA0MTgzQy0wLjAwMTI4Nzk2IDAuNTE4MDg4IDAuMDc2NjAyNCAwLjMzOTIyMiAwLjIxNjMyNSAwLjIwNzA5NUMwLjM1NjQ4MSAwLjA3NDU1MjkgMC41NDcyNjcgLTIuODM3MTZlLTA3IDAuNzQ2Mjk0IC0yLjc1NTU2ZS0wN0MwLjk0NTMyMiAtMi42NzM5NmUtMDcgMS4xMzYxMSAwLjA3NDU1MjkgMS4yNzYyNiAwLjIwNzA5NUwzLjczMjA0IDIuNTEwNUw2LjE4NzgxIDAuMjIxMDk4QzYuMzc3MTUgMC4wNDM1MDU1IDYuNjUzMTIgLTAuMDI1ODUyMiA2LjkxMTc2IDAuMDM5MTUxMUM3LjE3MDQgMC4xMDQxNTQgNy4zNzI0MyAwLjI5MzY0MyA3LjQ0MTczIDAuNTM2MjM5QzcuNTExMDMgMC43Nzg4MzUgNy40MzcwOSAxLjAzNzY4IDcuMjQ3NzUgMS4yMTUyN0w0LjI2MjAxIDMuOTk0NzdaIiBmaWxsPSIjNkE4OTkxIi8+Cjwvc3ZnPgo=');\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 10px;\n}\n\n.radio-primary {\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 50%;\n\tappearance: none;\n\t-webkit-appearance: none;\n\tbackground-color: #D3E1ED;\n\tposition: relative;\n\tcursor: pointer;\n}\n\n.radio-primary:checked {\n  background-color: #40A0C1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
